import dayjs from 'dayjs';

import { ApiTravelDateCandidate } from '@ibe/api';
import { INVALID_DATE_STRING } from '../Components/Datepicker/DateRangeInput/DateRangeInputProps';

abstract class DealFinderUtil {
  public static baseCondition(
    _date: Date,
    cachedPeriod: number | undefined,
    timezone?: string,
    travelDates?: Array<ApiTravelDateCandidate>
  ): boolean {
    if (cachedPeriod === undefined) {
      return true;
    }
    const price = this.findPackageTravelDate(_date, travelDates)?.price;
    const hasPrice = price !== undefined;
    const isDateAfterCachedPeriod = this.isAfterCachedPeriod(_date, cachedPeriod, timezone);

    if (isDateAfterCachedPeriod) {
      return true;
    }
    return hasPrice;
  }

  public static findPackageTravelDate(
    date: Date,
    travelDates?: Array<ApiTravelDateCandidate>
  ): ApiTravelDateCandidate | undefined {
    let relatedPackageTravelDate: ApiTravelDateCandidate | undefined = undefined;
    if (travelDates) {
      relatedPackageTravelDate = travelDates.find(travelDate => {
        return dayjs(travelDate.startDate).isSame(date, 'day');
      });
    }
    return relatedPackageTravelDate;
  }

  public static isAfterCachedPeriod(
    date: Date,
    cachedPeriod: number | undefined,
    timezone?: string
  ): boolean {
    if (cachedPeriod === undefined) {
      return false;
    }
    const cachePeriodEndDate = dayjs()
      .tz(timezone ?? 'Etc/UTC')
      .add(cachedPeriod, 'days');

    return dayjs(date).isAfter(cachePeriodEndDate);
  }

  public static isDateInRange(
    date: Date,
    startDate: string,
    maxDateRangeSpan: number | undefined
  ): boolean {
    let inRange = true;

    const from = dayjs(startDate);
    const testedDate = dayjs(date);
    if (maxDateRangeSpan) {
      const endOfMaxRange = from.add(maxDateRangeSpan, 'day');
      inRange = testedDate.isBetween(from, endOfMaxRange, 'day', '[]');
    }

    return inRange;
  }

  public static isNotValidDate(dateString: string | undefined): boolean {
    return !dateString || dateString == INVALID_DATE_STRING;
  }

  public static allPreviousDatesInRangePassBaseCondition(
    date: Date,
    startOfRange: string,
    cachedPeriod: number | undefined,
    timezone?: string,
    travelDates?: Array<ApiTravelDateCandidate>
  ) {
    let result = true;

    const from = dayjs(startOfRange);
    const testedDate = dayjs(date);

    let current = from.add(1, 'day');
    while (current.isBefore(testedDate)) {
      const currentAllowed = this.baseCondition(
        current.toDate(),
        cachedPeriod,
        timezone,
        travelDates
      );
      if (!currentAllowed) {
        result = false;
        break;
      }
      current = current.add(1, 'day');
    }
    return result;
  }
}

export default DealFinderUtil;
